import React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store/index";
import { useTranslation } from "react-i18next";

interface IProps {
    status?: string;
}

const CreditStatus: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    return (
        <div className="box">
            <div className="box-header col-xs-12 col-sm-12" style={{ backgroundColor: "#F4F4F4" }}>
                <div className="content-sub-title text-align-center">
                    <div className="monitoring-alert-icon" style={{ fontSize: "40px" }}>
                        <em className="las la-exclamation-circle "></em>
                    </div>
                </div>
            </div>
            <div className="box-content text-align-center">
                {props.status === "tu-thin-error" && (
                    <div className="msg-generic">
                        {tLang("credit.creditScore.creditScoreWidget.label.notEnoughInformation1")}{" "}
                        <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>{" "}
                        {tLang("credit.creditScore.creditScoreWidget.label.notEnoughInformation3")}
                        <div className="space-divider margin-top-l" />
                    </div>
                )}
                {props.status === "tu-down" && (
                    <div className="msg-generic">
                        {tLang("credit.creditScore.creditScoreWidget.label.notEnoughInformation2")}{" "}
                        <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>{" "}
                        {tLang("credit.creditScore.creditScoreWidget.label.notEnoughInformation3")}
                        <div className="space-divider margin-top-l" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreditStatus;
